import { FlightAirportClass } from "./flightAirportClass/flightAirportClass";

export interface RequestFlightAirportInterface {
  arrivalCountrySlug?: string;
  arrivalAirportCode?: string;
  departureAirportCode?: string;
  airlineCode?: string;
  arrivalCitySlug?: string;
}
export interface Root {
  data: FlightAirport;
}

export interface BoxSearchInterface {
  departure: BoxSearchLegInterface;
  arrival: BoxSearchLegInterface;
}

export interface BoxSearchLegInterface {
  name: string;
  slug: string;
  code: string;
  cityName: string;
  countryName: string;
  citySlug: string;
  countrySlug: string;
}

export interface FlightAirport {
  listMonth: ListMonth[];
  currency: string;
  airportRecommend: AirportRecommend[];
  thingsToKnow: ThingsToKnow;
  boxSearch: BoxSearchInterface;
}

export interface ListMonth {
  date: string;
  month: string;
  year: number;
  value: number;
  currency: string;
  percent: number;
}

export interface AirportRecommend {
  code: string;
  name: string;
  countSearch: number;
}

export interface ThingsToKnow {
  price: number;
  month: string;
  duration: string;
}

export class ResponseFlightAirport {
  status: boolean = false;

  code: string = "";

  message: string = "";

  data: FlightAirport = new FlightAirportClass();

  constructor(data?: any) {
    if (!data) return;
    this.status = data?.status || false;
    this.code = data?.code || "";
    this.message = data?.message || "";
    this.data = new FlightAirportClass(data?.data);
  }
}
